// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-indicator[data-v-7e956034]{position:absolute;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center}.loading-indicator main[data-v-7e956034]{width:2rem;height:2rem;border:.25rem solid #5e95c8;border-left-color:transparent;border-radius:50%;animation:spin-7e956034 infinite 1s linear}@keyframes spin-7e956034{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}", ""]);
// Exports
module.exports = exports;
